<template>
  <v-chip>
    유효시간 {{ filteredTwoDigits(duration.hours()) }}:{{
      filteredTwoDigits(duration.minutes())
    }}:{{ filteredTwoDigits(duration.seconds()) }}
  </v-chip>
</template>

<script>
export default {
  props: ['expireTime'],
  data() {
    return {
      now: this.$moment(),
    }
  },
  watch: {
    expireIn(v) {
      if (v < 1) {
        this.$emit('timeOut')
      }
    },
  },
  computed: {
    expireIn() {
      return this.expireTime.diff(this.now)
    },
    duration() {
      return this.$moment.duration(this.expireIn)
    },
  },
  created() {
    this.interval()
  },
  methods: {
    interval() {
      this.now = this.$moment()
      if (this.expireIn > 0) {
        setTimeout(this.interval, 1000)
      }
    },
    filteredTwoDigits(v) {
      return String(v).padStart(2, '0')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.v-chip {
  border-radius: 25px !important;
  background-color: $pinkred-10 !important;

  > &__content {
    color: $pinkred-110 !important;
    font-weight: bold !important;
    font-size: 12px !important;
  }
}
</style>
